import "./Media.css";
import { CSSProperties, useContext } from "react";
import { usePreference } from "../../../context/usePreference";
import thousandSeparator from "../../../utils/ThousandSeparator";
import { GetArrayDataCollectionList } from "../../../utils/arrayHelperList";
import { handleValueDataAudienceIndice, handleValueDataEmpytAudienceIndice } from "../Minute/MinuteUtils";
import { getDataObjArray } from "../Sidebar/SideBarUtils";
import { UiContext } from "../../../context/UiContext";

export function MediaTableRow({ audienceMediaFirstTable, rowContent, rowID }) {
  const row: string[] = [];
  let typerow = audienceMediaFirstTable[rowID][2];
  const {
    channelsLength } = useContext(UiContext);
  rowContent.map((val, valId) => {
    if (valId < rowContent.length) {
      row.push(val);
    }
  });

  const u = usePreference();
  const Indice = u.userPreference?.Indice;

  const rowHeight: CSSProperties = {
    height: u.userPreference?.TipoBase == 0 ? "50px" : "72px",
    width: "1000px",
    color: typerow == "0" ? "#7C6617" : "white",
  };

  let classColor = rowID % 2 == 0 ? "Media_tableRow" : "Media_tableRow even";

  if (rowID == 0) {
    classColor += " type1";
  } else if (typerow == "0") {
    classColor = "Media_tableRowAlert";
  }

  function formatFirstPart(first: string, indice: number): string {
    if (!first) return "";
    if (first === "-" || indice !== 5) {
      return thousandSeparator.formatWithSeparator(first);
    }
    return `${first}%`;
  }

  function formatSecondPart(second: string): string {
    if (!second) return "";
    return handleValueDataEmpytAudienceIndice(second, "%");
  }

  function renderRows(indice) {
    const renderDefaultCell = (val) => (
      <td className="Media_cellRows" key={val.ValueId}>
        {val.DataValueArray.split("|")[0] !== undefined && val.DataValueArray.split("|")[0] !== null
          ? handleValueDataEmpytAudienceIndice(val.DataValueArray.split("|")[0], "%")
          : ""}
      </td>
    );

    const renderSpecialCell = (val) => (
      <td className="Media_cellRows" key={val.ValueId}>
        {renderCell(val.DataValueArray)}
      </td>
    );

    const renderIndiceZeroCell = (val) => (
      <td className="Media_cellRows" key={val.ValueId}>
        {val.DataValueArray.split("|")[0] !== undefined && val.DataValueArray.split("|")[0] !== null
          ? thousandSeparator.formatWithSeparator(val.DataValueArray.split("|")[0])
          : ""}
      </td>
    );

    const renderCell = (val: string) => {
      const [first, second] = val?.split("|") ?? ["", ""];
      const isDefaultDash = val === "-|-";
      const firstPart = isDefaultDash ? "-" : formatFirstPart(first, indice);
      const secondPart = isDefaultDash ? "-" : formatSecondPart(second);

      return (
        <div>
          {firstPart}
          <br />
          <span>{secondPart}</span>
        </div>
      );
    };
    const renderCellEmpty = (val) => {
      return (
        <td
          className={"tableFirstGridYellow Media_cellRows"}
          key={val} 
          style={{
            borderLeft: "1px solid #fff",
          }}
        >
          {""}
        </td>
      );
    }
    const renderBaseMinimaConsolidado = (val) => {
      return (
        <td
          className={"tableFirstGridYellow Media_cellRows"}
          key={val} 
          style={{
            borderLeft: "1px solid #fff",
          }}
        >
          {renderCell(val.DataValueArray)}
        </td>
      );
    }
    const dataList = getDataObjArray(row);
    if (audienceMediaFirstTable[rowID][1] === "" && audienceMediaFirstTable[rowID][2] === '0' && rowContent.length === 0 && rowContent[rowID] === undefined) {
      return Array.from({ length: channelsLength }, (_, index) => renderCellEmpty(index));
    }
    if (audienceMediaFirstTable[rowID][1] === "" && audienceMediaFirstTable[rowID][2] === '0' && rowContent.length > 0 && rowContent[rowID] !== "") {
      return dataList.map(renderBaseMinimaConsolidado);
    }
    switch (indice) {
      case 0:
        return dataList.map(renderIndiceZeroCell);
      case 3:
      case 4:
      case 5:
        return dataList.map(renderSpecialCell);
      default:
        return dataList.map(renderDefaultCell);
    }
  }
  return (
    <tr className={classColor} style={rowHeight}>
      {renderRows(Indice)}
    </tr>
  );
}
